import { h } from 'preact';
import s from "./tinyHeader.module.css";

import logo from "../../../assets/images/logos/logo_colorida.svg";
import {Link} from "preact-router/match";
import {useAppContext, useUserContext} from '../../../contexts';
import {useMediaQuery} from "../../../hooks";

const TinyHeader = () => {
    // Validates if logo should be aligned to the left side according to the location path
    const shouldAlignToTheLeft =
        window.location.pathname === "/criar-conta" ||
        window.location.pathname === "/finalizar-cadastro";

    const matches = useMediaQuery('(max-width: 768px)');

    // URL parameters
    const urlParams = new URLSearchParams(window.location.search);
    // Searches for the "onboarding" querystring at the path url
    const onboardingLayout = urlParams.get('onboarding');
    // This is used to hide the second and the third header rows at the onboarding page
    const isOnboardingPage =
        window.location.pathname === "/entre" &&
        onboardingLayout &&
        !matches;

    // Accessibility feature data
    const {highContrast} = useAppContext();

    const [{}, {}, {}, {
        storeLogo,
    }] = useUserContext();

    // The Sabin store logo
    const logoSrc =
        typeof storeLogo !== "undefined" ? (storeLogo || logo) : "";

    if (isOnboardingPage) {
        return null;
    }

    return (
        <header className={`container-fluid border-b ${s.container} ${highContrast ? "grayBackground" : ""}`}>
            <div
                className={`sabin-container h-full flex items-center ${!shouldAlignToTheLeft ? " justify-center" : " justify-start"}`}
                data-testid="tiny-header-image-container"
            >
                <div className={"h-full flex items-center gap-x-2 md:gap-x-4"}>
                    <Link href="/" className={`${highContrast ? "whiteImage" : ""}`}>
                        <img
                            src={logoSrc}
                            // className={"h-9 md:h-12"}
                            className={"h-10 md:h-14"}
                            alt={"Sabin logo"}
                            data-testid="tiny-header-image"
                        />
                    </Link>
                    <p className={`uppercase ${s.storeCall} ${highContrast ? "highTitleFirst" : ""}`}>
                        |&nbsp;&nbsp;Loja virtual
                    </p>
                </div>
            </div>
        </header>
    )
}

export default TinyHeader;
